import * as React from "react";
import * as angular from "angular";
import {connect, Provider} from "react-redux";
import server from "../../../../integration/server/server-services";
import {applyMiddleware, createStore} from "redux";
import {default as reducers} from "../reducers";
import {InitContractList, initContractList} from "../actions";
import nvdbapi from "../../../../integration/nvdbapi/nvdbapi";

import thunk from "redux-thunk";
import * as selectors from "../selectors";

import security from "../../../../service/security/security-services";
import {ContractResults} from "./contractResults";
import ContractlistState from "../ContractlistState";


export class ServerHolder {
    constructor(
        public security: security = null,
        public server: server = null,
        public scope: ng.IRootScopeService = null,
        public nvdbapi: nvdbapi = null,
        public $q: angular.IQService = null
    ) {
    }
}

const serverHolder = new ServerHolder();
const store = createStore(reducers, applyMiddleware(thunk.withExtraArgument(serverHolder)));

interface StateProps {
}

interface DispatchProps {
    doInitContractList: InitContractList,
}

type Props = DispatchProps & StateProps;


interface ContractlistProps {
    server: server,
    security: security,
    nvdbapi: nvdbapi,
    $rootScope: any,
    $q: angular.IQService,
    doInitContractList: InitContractList,
}


class ContraclistView extends React.Component<Props, {}> {

    componentWillMount(): void {
        this.props.doInitContractList();
    }

    render() {


        return (
            <div className={"contract-list"}>

                <h1>Kontrakter</h1>
                 <ContractResults />

            </div>
        );
    }

}




export class Contractlist2 extends React.Component<ContractlistProps, {}> {
    render() {
        const mapStateToProps = (state: ContractlistState) => {
            return {
                fetchingContracts: selectors.fetchingContracts(state),
            }
        };

        const mapDispatchToProps = ({
            doInitContractList: initContractList,
        });

        serverHolder.security = this.props.security;
        serverHolder.server = this.props.server;
        serverHolder.scope = this.props.$rootScope;
        serverHolder.nvdbapi = this.props.nvdbapi;
        serverHolder.$q = this.props.$q;

        const Contractlist = connect(mapStateToProps, mapDispatchToProps)(ContraclistView);
        return (
            <Provider store={store} key="provider">
                <Contractlist/>
            </Provider>
        )
    }
}
